import React from 'react';

const Blogs = () => {
    return (
        <div id="blog" style={{textAlign: 'center'}}>
            <h2>Blogs</h2>
            <h3>Will be Uploading Soon.....</h3>
        </div>
    );
};

export default Blogs;